import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'csi-doctor-notes-card',
  templateUrl: './doctor-notes-card.component.html',
  styleUrls: ['./doctor-notes-card.component.scss'],
  animations: [
    trigger('floatingCardAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(12px) scale(0.98)' }),
        animate('180ms ease-out', style({ opacity: 1, transform: 'translateX(0) scale(1)' }))
      ]),
      transition(':leave', [
        animate('140ms ease-in', style({ opacity: 0, transform: 'translateX(8px) scale(0.98)' }))
      ])
    ])
  ]
})
export class DoctorNotesCardComponent {
  @Input() isLocked: boolean;
  @Input() hasAssessmentSnapshot: boolean;
  @Input() hasSignsSummary: boolean;
  @Input() doctorNotesLength: number;
  @Input() doctorNotesControl: AbstractControl;

  @Output() closed = new EventEmitter<void>();
  @Output() addTimestamp = new EventEmitter<void>();
  @Output() addSnapshot = new EventEmitter<void>();
  @Output() addSignsSummary = new EventEmitter<void>();
  @Output() clearNotes = new EventEmitter<void>();
}
